import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners, provideAppInitializer, inject, isDevMode, LOCALE_ID, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { DiagnosticsService } from './shared/support/diagnostics.service';
import { OverlayMaskCleanupService } from './core/services/overlay-mask-cleanup.service';
import { GlobalErrorHandler } from './shared/support/global-error-handler';
import { diagnosticsInterceptor } from './shared/support/diagnostics.interceptor';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { PRIMENG_ES } from './core/i18n/primeng-es';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { apiResponseInterceptor } from './core/interceptors/api-response.interceptor';
import { saveTimeoutInterceptor } from './core/interceptors/save-timeout.interceptor';
import { provideServiceWorker } from '@angular/service-worker';

// Toda la app en español (México): fechas (EEEE/MMMM), números y moneda con el pipe `date`/`number`/`currency`.
registerLocaleData(localeEsMx);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'es-MX' },
    // Montos en pesos: el pipe `currency` sin código muestra "$" (MXN) en vez del USD por defecto.
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'MXN' },
    provideBrowserGlobalErrorListeners(),
    // Ingesta de errores del frontend (opcional y a prueba de fallos).
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor, apiResponseInterceptor, diagnosticsInterceptor, saveTimeoutInterceptor])),
    // Instala el recolector de diagnóstico para "Reportar un problema".
    provideAppInitializer(() => inject(DiagnosticsService).install()),
    // Quita la máscara de los paneles laterales al cerrarlos (sin ella la pantalla queda congelada).
    provideAppInitializer(() => inject(OverlayMaskCleanupService).install()),
    providePrimeNG({
        // Textos integrados de PrimeNG en español (paginador, calendario, filtros, etc.)
        translation: PRIMENG_ES,
        theme: {
            preset: Aura,
            options: {
                // Controlar dark mode con la clase .p-dark que gestiona LayoutService,
                // en lugar del default "system" (prefers-color-scheme: dark)
                darkModeSelector: '.p-dark'
            }
        }
    }), provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          })
  ]
};
